import { onBeforeUnmount, onMounted, ref } from 'vue';
import type { Ref } from 'vue';

type NodeMenu = {
  menu: Ref<HTMLDetailsElement | null>;
  closeMenu: () => void;
  handleToggle: () => void;
};

let activeMenu: HTMLDetailsElement | null = null;
let mountedMenus = 0;

function closeActiveMenuIfOutside(event: PointerEvent): void {
  if (!activeMenu?.open) {
    activeMenu = null;
    return;
  }

  if (!(event.target instanceof Node) || activeMenu.contains(event.target)) {
    return;
  }

  activeMenu.open = false;
  activeMenu = null;
}

export function useNodeMenu(): NodeMenu {
  const menu = ref<HTMLDetailsElement | null>(null);

  function closeMenu(): void {
    if (menu.value) {
      menu.value.open = false;
    }

    if (activeMenu === menu.value) {
      activeMenu = null;
    }
  }

  function handleToggle(): void {
    const element = menu.value;
    if (!element?.open) {
      if (activeMenu === element) {
        activeMenu = null;
      }

      return;
    }

    document.querySelectorAll<HTMLDetailsElement>('.node-menu[open]').forEach(openMenu => {
      if (openMenu !== element) {
        openMenu.open = false;
      }
    });

    activeMenu = element;
  }

  onMounted(() => {
    if (mountedMenus === 0) {
      document.addEventListener('pointerdown', closeActiveMenuIfOutside);
    }

    mountedMenus += 1;
  });

  onBeforeUnmount(() => {
    if (activeMenu === menu.value) {
      activeMenu = null;
    }

    mountedMenus -= 1;
    if (mountedMenus === 0) {
      document.removeEventListener('pointerdown', closeActiveMenuIfOutside);
    }
  });

  return {
    menu,
    closeMenu,
    handleToggle
  };
}
